import { render, staticRenderFns } from "./catalog-item-hover-slider.vue?vue&type=template&id=7f59a006&scoped=true"
import script from "./catalog-item-hover-slider.vue?vue&type=script&lang=js"
export * from "./catalog-item-hover-slider.vue?vue&type=script&lang=js"
import style0 from "./catalog-item-hover-slider.vue?vue&type=style&index=0&id=7f59a006&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f59a006",
  null
  
)

export default component.exports